import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import CandidateCard from "./CandidateCard";
import CandidateProfile from "./CandidateProfile";
import Pipeline from "./Pipeline";
import EmptyCandidates from "./EmptyCandidate";
import { PIPELINE_STEPS } from "variables/constants";
import {
    Users,
} from "lucide-react";
import Card from "components/card";
import { 
	getApplicantList, getPipelineStats
} from "../../../../redux/recruitment/recruitmentState";
import SearchBar from "components/search/SearchBar";

const CandidateBoard = ({ recordList, pagination, doSearch, jobRoleRequestId, 
    filters, doSearchApplicants, 
    getPipelineStatsData, pipelineData}) => {

    const [selected, setSelected] = useState(null);

    useEffect(() => {
        doSearchApplicants({paginate: pagination.per_page, sort_by_score: 'desc', jobRoleRequestId});
        setSelected(null);
    }, [doSearch, pagination.per_page]);

    useEffect(() => {
        getPipelineStatsData({id:jobRoleRequestId});
    }, [getPipelineStatsData, jobRoleRequestId]);

    const handlePipelineFilter = (stepId, isRejected=0) => {
        if(filters.stepId === stepId && filters.isRejected === isRejected){
            stepId = 0;
            isRejected = 0;
        }
        setSelected(null);
        doSearchApplicants({paginate: pagination.per_page, sort_by_score: 'desc', jobRoleRequestId, stepId, isRejected});
    }

    return (
        <div className="flex flex-col">
            <div className="space-y-6">
                <Pipeline 
                    steps={pipelineData} 
                    filterHandler={handlePipelineFilter}
                    activeStep={filters.stepId}
                    activeRejected={filters.isRejected}/>
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                    <div className="col-span-2">
                        <Card className="flex flex-col gap-6 rounded-2xl shadow-sm bg-white border-2 border-slate-200">
                            <div className="bg-gradient-to-br from-emerald-50 to-cyan-50 border-b rounded-t-2xl p-6 grid items-start gap-1.5">
                                <div className="flex items-center justify-between gap-2">
                                    <div className="min-w-0">
                                        <h4 className="text-[18px]">
                                            {filters.isRejected === 1 ? 'Rejected Candidates' : 'Active Candidates'}
                                        </h4>
                                        <p className="text-[14px] text-slate-700">
                                            {recordList?.length } candidates in pipeline
                                        </p>
                                    </div>
                                    <span className="inline-flex items-center justify-center w-6 h-6 rounded-lg px-2 py-0.5 font-medium  bg-gradient-to-br from-emerald-500 to-cyan-500 text-white text-[13px] flex-shrink-0">
                                        {recordList?.length }
                                    </span>
                                </div>
                            </div>
                            
                            <div className="p-6 pt-2 space-y-3">
                                <SearchBar
                                    placeholder="Search candidates..." 
                                    searchHandler={doSearchApplicants}
                                    filters={filters}
                                />
                                <div className="grid grid-cols-1 gap-4 overflow-y-auto max-h-[600px]">
                                    {recordList?.length === 0 ? (
                                        <EmptyCandidates />
                                    ) : (
                                        recordList?.map((candidate) => (
                                            <CandidateCard
                                                key={candidate.id}
                                                recordData={candidate}
                                                {...candidate}
                                                selected={selected?.id === candidate.id}
                                                onClick={() => setSelected(candidate)}
                                                stage={candidate.stage}
                                            />
                                        ))
                                    )}
                                </div>
                            </div>
                        </Card>
                    </div>

                    <div className="hidden lg:block">
                        {selected ? (
                            <CandidateProfile 
                                candidate={selected} 
                            />
                            ) : (
                            <div className="flex flex-col items-center justify-center h-[200px] text-gray-500 text-sm bg-white border-2 rounded-xl border-slate-300 border-dashed pb-6 px-4 py-12 text-center dark-mode-card">
                                <Users className="w-12 h-12 text-gray-800 mb-3 dark:text-white" />
                                <h4 className="text-[14px] font-semibold mb-2 dark:text-white">
                                    No Candidate Selected
                                </h4>
                                <p className="text-[12px] max-w-xs dark:text-slate-100">
                                    Select a candidate from the list to view their details and progress
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    recordList: state.recruitment.applicantList?.items,
    pagination: state.recruitment.applicantList?.pagination,
	filters: state.recruitment.applicantList?.filters,
  	requesting: state.recruitment.applicantList?.requesting,
  	error: state.recruitment.applicantList?.error,
    pipelineData: state.recruitment.pipelineStats?.data,
});

const mapDispatchToProps = (dispatch) => ({
    doSearchApplicants: (data) => dispatch(getApplicantList(data)),
    getPipelineStatsData: (data) => dispatch(getPipelineStats(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CandidateBoard);